module.exports = __webpack_public_path__ + "img/nat-geo-logo.89cf95d8.jpg";